import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { useAssetStatus, useStartLessonProgress, useStartTrackProgress } from '../userProgressQueries';
import { useHistory } from 'react-router-dom';
import { getListingUrl } from '../../../utils/RoutingUtils';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import Raven from 'raven-js';
// @ts-expect-error Could not find declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import { getShortContentUrl } from '../../shortContent/shortContentRouting';
import { useShortStatus } from '../../shortContent/shortContentHooks';
import getLang from 'academy-common-lib/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
const WideUIButton = styled(UIButton).attrs({
  'data-test-id': 'overview-enroll-button',
  use: 'primary'
}).withConfig({
  displayName: "EnrollButton__WideUIButton",
  componentId: "sc-1e83v6l-0"
})(["max-width:600px !important;", ""], mediaQuery('notMobile', css(["min-width:200px !important;"])));
const usePlaylistId = () => {
  const [[playlistId]] = useSearchParam('playlistId');
  return playlistId;
};
export const EnrollTrackButton = ({
  language,
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id
  });
  const [startTrackProgress, {
    startTrackProgressLoading
  }] = useStartTrackProgress({
    trackId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    startTrackProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'TRACK',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startTrackProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.track.${status}`
    })
  });
};
export const EnrollLessonButton = ({
  language,
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'LESSON',
    id
  });
  const [startLessonProgress, {
    startLessonProgressLoading
  }] = useStartLessonProgress({
    lessonId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    startLessonProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'LESSON',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startLessonProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.lesson.${status}`
    })
  });
};
export const EnrollShortButton = ({
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useShortStatus(id);
  const handleEnroll = () => {
    history.push(getShortContentUrl({
      shortId: id,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.short.${status}`
    })
  });
};